import { createSlice } from '@reduxjs/toolkit';

interface ToastState {
  message: string;
  isShow: boolean;
}

const initialState: ToastState = {
  message: '',
  isShow: false,
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast(state, action) {
      state.message = action.payload;
      state.isShow = true;
    },
    hideToast(state) {
      state.message = '';
      state.isShow = false;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
